/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import CustomOverLay from '../../../../../components/CustomOverLay';
import GlobalContext from '../../../../../components/Context/GloablContext';
import Emptyscreenwithouttitle from '../../../../../components/Emptyscreenwithouttitle';
import { useGetMonitorAssociatedToPatientListQuery } from '../../../../../slices/patientSlice';
import formatMobileNumber from '../../../../../CommonMethods/FormatMobileNumber';

// Monitor Row Component with Status Badges
function MonitorRow({ monitor, index }) {
    return (
        <tr key={index}>
            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                {monitor?.monitorUserData?.user_id}
            </td>
            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                {monitor?.monitorUserData?.last_name}, {monitor?.monitorUserData?.first_name}
            </td>
            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                {monitor?.monitorUserData?.main_country_code} {formatMobileNumber(monitor?.monitorUserData?.main_number)}
            </td>
            <td className="px-[18px] py-2 text-sm text-start font-normal">
                {monitor?.monitor_permission==='monitor'?'Monitor':'View'}
            </td>
            <td id={`SMS_Alert${index}`} className="px-[18px] py-2 text-sm text-start font-normal">
                <span className={`inline-flex items-center justify-center ${monitor?.sms_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                    {monitor?.sms_alert === true ? "ON" : "OFF"}
                </span>
            </td>
            <td id={`Email_Alert${index}`} className="px-[18px] py-2 text-sm text-start font-normal">
                <span className={`inline-flex items-center justify-center ${monitor?.email_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                    {monitor?.email_alert === true ? "ON" : "OFF"}
                </span>
            </td>
            <td id={`Missed_Reading${index}`} className="px-[18px] py-2 text-sm text-start font-normal">
                <span className={`inline-flex items-center justify-center ${monitor?.missed_reading_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                    {monitor?.missed_reading_alert === true ? "ON" : "OFF"}
                </span>
            </td>
        </tr>
    );
}

export default function MonitorViewTable({patient_id}) {
    const {isSideBar} = useContext(GlobalContext);
    const [queryParams,setQueryParams]=useState(`${patient_id}`)
    const {data,isFetching,isLoading,status}=useGetMonitorAssociatedToPatientListQuery(patient_id,{refetchOnMountOrArgChange:true})
    return (
        <>  
            {<>
                <div className='border border-[#EDD7E1] mt-4 rounded'>
                    <div className='relative flex border-b border-[#EDD7E1] justify-between items-center py-3.5 pr-4 pl-[18px]'>
                        <p id='Monitor-List' className='text-base font-semibold text-[#972E4C]'>Monitor Users List</p>
                    </div>
                    {data?.data && data?.data.length === 0
                        ? <Emptyscreenwithouttitle customHeight={false} FirstPTag={"No monitors linked yet"} />
                        :
                        <div data-testid='Monitor-table' className='overflow-auto scrollbar_purple pb-2'>
                            { ((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Monitor List..." classKey={` top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-auto ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>: <>
                                <table aria-label="Outside Table" className="w-full table-auto">
                                    <thead>
                                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm z-[1] sticky top-0 left-0">
                                            <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm xl:min-w-[254px] min-w-[160px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Monitor ID
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 xl:min-w-[260px] min-w-[200px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Monitor Name
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 xl:min-w-[250px] min-w-[200px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Main Number
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[160px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Permission Access
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[150px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Alerts by SMS
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[150px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Alerts by Email
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[220px] rounded-tr-sm rounded-br-sm">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Include Missed Readings
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        
                                        {data?.data && data?.data?.length>0 && data?.data?.map((Monitor, index) => (
                                            <MonitorRow 
                                                key={Monitor?._id || index}
                                                monitor={Monitor}
                                                index={index}
                                            />
                                        ))}
                            
                                    </tbody>
                                </table>
                    
            
                            </>}
                        </div>
                    }
                </div>
            </>}
        </>
    )
}
